import { useCallback, useEffect, useState } from 'react';
import { NWClient } from '../../../client/NWClient';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

export const useDocumentContent = (docId: number, fileType: string) => {
  const { t } = useTranslation();
  const [fileBlobURL, setFileBlobURL] = useState<string>(null);
  const [pdfBlobMode, setPDFBlobMode] = useState<boolean>(true);
  const [fileLoading, setFileLoading] = useState<boolean>(false);
  const [documentHTML, setDocumentHTML] = useState<string>('Something in the way');
  const [params] = useSearchParams();
  const generateTemplateParam = params.get('generateTemplate');
  const editDocumentParam = params.get('editDocument');
  const creatingDocumentBlob = useCallback(
    (open?: boolean) => {
      setFileLoading(true);
      NWClient.getDocumentBlob(docId)
        .then((res: string) => {
          setFileBlobURL(res);
          if (open) {
            window.open(res, '_blank');
          }
        })
        .catch((error) => {
          toast.error(error.message || t('messages.errorOccurred'));
        })
        .finally(() => setFileLoading(false));
    },
    [docId, t]
  );

  const getImageBlob = useCallback(() => {
    setFileLoading(true);
    NWClient.getDocumentBlob(docId)
      .then((res: string) => {
        setFileBlobURL(res);
      })
      .catch((error) => {
        toast.error(error.message || t('messages.errorOccurred'));
      })
      .finally(() => setFileLoading(false));
  }, [docId, t]);

  const blobHandling = useCallback(() => {
    if (fileType === 'pdf' && docId) {
      creatingDocumentBlob();
    }

    if (fileType && ['jpg', 'jpeg', 'png', 'heic'].includes(fileType.toLowerCase()) && docId) {
      getImageBlob();
    }
  }, [docId, fileType, creatingDocumentBlob, getImageBlob]);

  useEffect(() => {
    blobHandling();
  }, [blobHandling]);

  useEffect(() => {
    if (generateTemplateParam || editDocumentParam) {
      setPDFBlobMode(false);
    }
  }, [generateTemplateParam, editDocumentParam]);
  return {
    fileBlobURL,
    fileLoading,
    creatingDocumentBlob,
    setPDFBlobMode,
    pdfBlobMode,
    documentHTML,
    setDocumentHTML,
  };
};
